import React, { useEffect } from "react";
import { Modal, Box, Stack, Typography, TextField, Button } from "@mui/material";
import { useForm, Controller } from "react-hook-form";

interface ModalProps {
    open: boolean;
    handleClose: () => void;
    fields: { key: string; label: string; value: string; required?: boolean }[];
    loading: boolean;
    onSubmit: (data: any) => void;
    bankCode: string;
    isEditing?: boolean;
}

export const MerchantBankDynamicFieldsModal = ({
    open,
    handleClose,
    fields,
    loading,
    onSubmit,
    bankCode,
    isEditing = false
}: ModalProps) => {
    const { control, handleSubmit, reset } = useForm<Record<string, string>>({
        defaultValues: fields.reduce((acc, field) => ({
            ...acc,
            [field.key]: field.value || ''
        }), {})
    });

    useEffect(() => {
        reset(fields.reduce((acc, field) => ({
            ...acc,
            [field.key]: field.value || ''
        }), {}));
    }, [fields, open, bankCode, reset]);

    const handleFormSubmit = (data: any) => {
        const parameters = Object.entries(data).map(([key, value]) => ({
            key,
            value: String(value || '')
        }));

        onSubmit({
            parameters
        });
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: "background.paper",
                p: 4,
                borderRadius: 2,
                minWidth: 400,
                maxWidth: 500,
                maxHeight: '80vh',
                overflowY: 'auto'
            }}>
                <Typography variant="h6" mb={2}>
                    {isEditing ? 'Banka Detayları' : 'Banka Yetkilendirme'}
                </Typography>
                <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <Stack spacing={2}>
                        {fields.map((field, idx) => (
                            <Controller
                                key={idx}
                                name={field.key}
                                control={control}
                                defaultValue={field.value || ''}
                                rules={{ required: field.required }}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <TextField
                                        label={field.key}
                                        value={value}
                                        onChange={onChange}
                                        error={!!error}
                                        helperText={error?.message}
                                        required={field.required}
                                        fullWidth
                                    />
                                )}
                            />
                        ))}
                    </Stack>
                    <Stack direction="row" justifyContent="flex-end" spacing={2} mt={3}>
                        <Button variant="outlined" onClick={handleClose}>
                            Kapat
                        </Button>
                        <Button 
                            variant="contained" 
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? 'Kaydediliyor...' : 'Kaydet'}
                        </Button>
                    </Stack>
                </form>
            </Box>
        </Modal>
    );
};
